module.exports = __webpack_public_path__ + "img/submit-top.a646b27c.png";